import { FC } from 'react';

import { SiteFooterNavigation } from './shared/SiteFooterNavigation';

export const Footer: FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="border-t py-6 sm:py-8">
            <div className="container px-4 sm:px-6 lg:px-8">
                <SiteFooterNavigation tcgListTestId="footer-tcg-list" />

                <div className="mt-6 border-t pt-6 text-center text-xs text-muted-foreground sm:mt-8 sm:pt-8 sm:text-sm">
                    <p>{`© ${currentYear.toString()} CartOn. Всі права захищені.`}</p>
                    <p className="mt-1">
                        {
                            "Всі продукти TCG та пов'язані з ними медіа є торговими марками їх відповідних власників."
                        }
                    </p>
                </div>
            </div>
        </footer>
    );
};
